import React from 'react'
import { compose } from 'redux'
import { injectIntl } from 'react-intl'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import cx from 'classnames'
import moment from 'moment'
import _ from 'lodash'

class CircularDatePicker extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
    }
  }

  renderSuffix = (date) => {
    const today = moment()
    const tomorrow = moment().add(1, 'days')
    const theDayAfterTomorrow = moment().add(2, 'days')
    if (moment(date).isSame(today, 'day')) return 'Today'
    if (moment(date).isSame(tomorrow, 'day')) return 'Tomorrow'
    return null
  }

  render () {
    const { classes, className, directory, handleDateChange, dates } = this.props

    const availableDates = dates.map(d => {
      const month = moment(d).lang('en').format('MMM')
      const day = moment(d).lang('en').format('DD')
      const weekday = moment(d).lang('en').format('ddd')
      const suffix = this.renderSuffix(d)
      return { month, day, weekday, suffix, date: d }
    })

    return (
      <div
        className={cx(classes.circularDatePicker, className)}
        style={{ margin: '0px -24px' }}
      >
        {_.map(availableDates, (d, index) => {
          const { month, day, weekday, suffix, date } = d
          const isSelected = directory.selectedDate === date

          return (
            <div
              key={index}
              className={cx(classes.date, { [classes.selectedDate]: isSelected })}
              onClick={() => handleDateChange(date)}
            >
              <p className={classes.month}>{month}</p>
              <p className={classes.day}>{day}</p>
              {suffix
                ? <p className={classes.weekday}>{`${suffix}`}</p>
                : <p className={classes.weekday}>{weekday}</p>
              }
            </div>
          )
        })}
      </div>
    )
  }
}

const styles = {
  circularDatePicker: {
    display: 'flex',
    overflowX: 'scroll',
    padding: '24px 0px',
  },
  date: {
    flexShrink: 0,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#FFE8AA',
    borderRadius: 800,
    width: 94,
    height: 94,
    margin: '0px 8px',
    '& > p': {
      margin: 0,
    },
  },
  selectedDate: {
    backgroundColor: '#EBBD3F',
  },
  month: {
    fontSize: 14,
    fontWeight: 300,
  },
  day: {
    fontSize: 25,
    fontWeight: 500,
    lineHeight: '36px',
  },
  weekday: {
    fontSize: 12,
    fontWeight: 300,
  },

}

const mapStateToProps = (state) => {
  return {
    directory: state.directory,
  }
}

const mapDispatchToProps = {
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withStyles(styles),
  injectIntl,
)(CircularDatePicker)



// WEBPACK FOOTER //
// ./src/components/scenes/DirectoryPage/DatePicker/CircularDatePickerENG.jsx